import { equals } from "ramda";
import { type FC, memo, useEffect, useState } from "react";

import { RegionField, type RegionFieldProps } from "@/modules/entities/components/RegionField.tsx";

interface WorkflowRegionFieldProps extends Omit<RegionFieldProps, "genomeIds"> {
  // We are all connected activities to spot a genome param
  getSelectedGenomesIds: () => number[];
  isPlaybookContext?: boolean;
}

const WorkflowRegionFieldRender: FC<WorkflowRegionFieldProps> = (props) => {
  const { getSelectedGenomesIds, isDisabled, errorMessage, isPlaybookContext, onInternalErrorChange } = props;
  const [selectedGenomeIds, setSelectedGenomeIds] = useState<number[]>(getSelectedGenomesIds());

  useEffect(() => {
    const newGenomeIds = getSelectedGenomesIds();
    // We check 'by-value' equality to avoid unnecessary re-renders when
    // the array reference changes but the content is the same
    if (!equals(selectedGenomeIds, newGenomeIds)) {
      setSelectedGenomeIds(newGenomeIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSelectedGenomesIds]);

  return (
    <RegionField
      {...props}
      genomeIds={selectedGenomeIds}
      isDisabled={isDisabled ?? !selectedGenomeIds?.length}
      errorMessage={
        selectedGenomeIds?.length
          ? errorMessage
          : isPlaybookContext
            ? "A genome selection is required"
            : "No genomes have been set here or up in the activity tree"
      }
      onInternalErrorChange={onInternalErrorChange}
    />
  );
};

export const WorkflowRegionField = memo(WorkflowRegionFieldRender);
